<template>
    <div class="live-list">
        <video-list-skeleton v-if="isLoading" style="margin-bottom: 100vh"></video-list-skeleton>

        <div v-if="!isLoading && category_index === 0">
            <div class="live-list-header">
                <div class="live-list-header-search">
                    <van-search class="top-search" v-model="value">
                        <template v-slot:left-icon>
                            <img src="/static/v4/search_icon.svg" alt="" style="margin-top: 2px" />
                        </template>
                    </van-search>
                    <div class="live-list-header-search-swiper">
                        <van-swipe style="height: 36px;line-height: 36px" :autoplay="3000" vertical :show-indicators="false">
                            <van-swipe-item v-for="(item, index) in search_placeholder" :key="index" @click="jump(item)">
                                {{ item.title }}
                            </van-swipe-item>
                        </van-swipe>
                    </div>
                </div>

                <div class="tags">
                    <van-tabs :swipeable="true" v-model="category_index" @click="changeCategory">
                        <van-tab v-for="(item, index) in categories" :key="index" :title="item.title"></van-tab>
                    </van-tabs>
                    <div class="clear"></div>
                </div>

                <div class="live-list-header-swipe">
                    <van-swipe :autoplay="3000">
                        <van-swipe-item v-for="(item, i) in banners" :key="i" @click='goBanner(item)'>
                            <a :href="item.target_url.replace('https://dr-yyh.com', 'https://dr-yyh.com')">
                                <img :src="item.img" alt="" />
                            </a>
                        </van-swipe-item>
                    </van-swipe>
                </div>

                <!-- 我的预约 -->
                <div class="live-list-header-appointment" v-if="appointmentList !== null">
                    <div class="live-list-header-appointment-header">
                        <span>我的预约</span>
                        <span @click="$router.push({ name: 'live-appointment-list' })">查看更多 <van-icon name="arrow"/></span>
                    </div>
                    <div class="live-list-header-appointment-content" @click="go_detail(appointmentList)">
                        <div class="live-list-header-appointment-content-left">
                            <img :src="appointmentList.cover_img" />
                            <img v-if="appointmentList.live_status == 0" src="/static/img/live/icon_list_tag_live_count_down.svg" alt="" />
                            <img v-if="appointmentList.live_status == 1" src="/static/img/live/icon_list_tag_live_process.svg" alt="" />
                            <img v-if="appointmentList.live_status == 2" src="/static/img/live/icon_list_tag_live_history.svg" alt="" />
                        </div>
                        <div class="live-list-header-appointment-content-right">
                            <div>{{ appointmentList.title }}</div>
                            <div v-if="appointmentList && appointmentList.start_at">{{ appointmentList.start_at.substr(0, 16) }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div :class="[!isOption ? 'live-list-preview-list-open' : 'live-list-preview-list-stow']" v-if="forecast != null && forecast.length > 0">
                <div class="preview-title">直播中/预告</div>
                <div class="preview-section">
                    <div @click="go_detail(item)" v-for="item in forecastList" :key="item.id" class="preview-section-content">
                        <div class="preview-section-content-left">
                            <van-image fit="cover" :src="item.cover_img" />
                            <img v-if="item.live_status == 0" class="live-image-type" src="/static/img/live/icon_list_tag_live_count_down.svg" alt=""/>
                            <img v-else-if="item.live_status == 1" class="live-image-type" src="/static/img/live/icon_list_tag_live_process.svg" alt=""/>
                            <img
                                v-else-if="item.live_status == 2"
                                class="live-image-type"
                                src="/static/img/live/icon_list_tag_live_history.svg"
                                alt=""
                            />
                        </div>
                        <div class="preview-section-content-right">
                            <div class="title_style">{{ item.title }}</div>
                            <div v-if="item.start_at">{{ item.start_at.substr(0, 16) }}</div>
                            <div v-if="item.live_status == 0" :class="[item.isAppointment ? 'reserved' : 'reservation']" @click.stop="liveApply(item)">
                                {{ item.isAppointment ? '已预约' : '一键预约' }}
                            </div>
                            <div class="reservation" v-if="item.live_status == 1">加入</div>
                        </div>
                        <van-divider :style="{ borderColor: '#F2F2F2', padding: '10px 16px 0px 16px' }" />
                    </div>
                </div>

                <div v-if="forecast.length > 3" class="preview-option" @click.prevent="() => (isOption = !isOption)">
                    <div class="preview-option-content">
                        <span v-if="!isOption"> 展开<van-icon name="arrow-down" /> </span>
                        <span v-else>收起<van-icon name="arrow-up"/></span>
                    </div>
                </div>
            </div>

            <div class="live-list-conference" v-if="academicContent && academicContent.length">
                <div class="live-list-conference-header">
                    <span>直播专栏</span>
                    <span @click="$router.push({ name: 'live-column-list' })">查看更多 <van-icon name="arrow"/></span>
                </div>
                <div class="live-list-conference-content">
                    <div class="live-list-conference-content-left" v-for="item in academicContent.slice(0, 2)" :key="item.id">
                        <div class="live-list-conference-content-left" v-if="item.origin_type === 4" @click="goConference(item)">
                            <div class="live-list-conference-content-left-header">
                                <img :src="item.cover_img" alt="" />
                                <img v-if="item.type == 2" src="/static/v4/icon_list_tag_column.svg" alt="" />
                                <img v-else-if="item.live_status == 0" class="live-list-section-left-zl" src="/static/img/live/icon_list_tag_live_count_down.svg" alt=""/>
                                <img v-else-if="item.live_status == 1" class="live-list-section-left-zl" src="/static/img/live/icon_list_tag_live_process.svg" alt=""/>
                                <img v-else-if="item.live_status == 2" class="live-list-section-left-zl" src="/static/img/live/icon_list_tag_live_history.svg" alt=""/>
                            </div>
                            <div class="live-list-conference-content-left-title" style="padding-top:0px">
                                <div class="title_style">{{ item.title }}</div>
                                <div>共{{ item.current_count }}期 {{ item.view_count }}人观看</div>
                            </div>
                        </div>
                        <div class="live-list-conference-content-left" v-else-if="item.origin_type === 13" @click="goConference(item)">
                            <div class="live-list-conference-content-left-header">
                                <img :src="item.cover_img" alt="" />
                            </div>
                            <div class="live-list-conference-content-left-title" style="padding-top:0px">
                                <div class="title_style">{{ item.title  }}</div>
                                <div>共{{ item.total_count }}期 {{ item.view_count }}人观看</div>
                            </div>
                        </div>
                        <div class="live-list-conference-content-right" v-else-if="item.origin_type === 14" @click="goConference(item)">
                            <div class="live-list-conference-content-right-header">
                                <img :src="item.cover_img" alt="" />
                                <img v-if="item.meeting_status == 0" class="live-list-section-right-zl" src="/static/img/live/icon_list_tag_live_count_down.svg" alt=""/>
                                <img v-if="item.meeting_status == 1" class="live-list-section-right-zl" src="/static/img/live/icon_list_tag_academic_process.svg" alt=""/>
                                <img v-if="item.meeting_status == 2" class="live-list-section-right-zl" src="/static/img/live/icon_list_tag_academic_end.svg" alt=""/>
                            </div>
                            <div class="live-list-conference-content-right-title">
                                <div class="title_style"> {{ item.title  }}</div>
                                <span v-if="item.meeting_status !== 2">
                                    <span class="enrollment" v-if="!item.isApply" @click.stop="goEnrollment(item)">报名参会</span>
                                    <span class="registered" v-else>已报名</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="live-list-everyone">
                <div class="live-list-everyone-title">大家都在看</div>
                <div class="live-list-everyone-conteng">
                    <img src="/static/v4/pic_live_calendar.svg" alt="" @click="go_calendar()" />
                    <img src="/static/v4/pic_live_news.svg" alt="" @click="go()" />
                </div>
            </div>

            <div class="live-list-playback">
                <div class="live-list-playback-title">精彩回放</div>
                <van-tabs v-model="backTabsActive" class="live-list-playback-header" @click="goTabBack">
                    <van-tab title="学术会议" name="1" />
                    <van-tab title="临床好课" name="2" />
                    <van-tab title="科研好课" name="3" />
                </van-tabs>
                <div class="live-list-playback-content">
                    <van-list :model="backLoading" :finished="backFinished" @load="backLoad()">
                        <div v-for="item in backs" :key="item.id" @click="go_detail(item)">
                            <div>
                                <LiveColumn v-if="item.type == 2" :dataItem="item"></LiveColumn>
                                <LiveSingle v-if="item.type == 1" :dataItem="item"></LiveSingle>
                                <van-divider :style="{ color: '#1989fa', borderColor: ' #F2F2F2' }" />
                            </div>
                        </div>
                    </van-list>
                </div>
            </div>
        </div>
        <div v-else-if="!isLoading && category_index !== 0">
            <div class="live-list-header" style="background: none">
                <div class="live-list-header-search">
                    <van-search class="top-search" v-model="value">
                        <template v-slot:left-icon>
                            <img src="/static/v4/search_icon.svg" alt="" style="margin-top: 2px" />
                        </template>
                    </van-search>
                    <div class="live-list-header-search-swiper">
                        <van-swipe style="height: 36px;line-height: 36px" :autoplay="3000" vertical :show-indicators="false">
                            <van-swipe-item v-for="(item, index) in search_placeholder" :key="index" @click="jump(item)">
                                {{ item.title }}
                            </van-swipe-item>
                        </van-swipe>
                    </div>
                </div>

                <div class="tags">
                    <van-tabs :swipeable="true" v-model="category_index" @click="changeCategory">
                        <van-tab :title-class="'course-list-category-title'" v-for="(item, index) in categories" :key="index" :title="item.title"></van-tab>
                    </van-tabs>
                </div>

                <van-list class="other-channe-list-warpper" v-model="contentLoading" :finished="contentFinished" :immediate-check="false" @load="onLoad">
                    <div @click="go_channel_detail(item)" v-for="item in otherChannelList" :key="item.id" class="other-channe-list">
                        <LiveSingle :dataItem="item" v-if="item.type === 2"></LiveSingle>
                        <LiveColumn :dataItem="item" v-else-if="item.items && item.items !== null && item.items.length > 0"></LiveColumn>
                        <LiveSingle :dataItem="item" v-else></LiveSingle>
                    </div>
                </van-list>
            </div>
        </div>

        <Overlay ref="overlayRef" :dataItem="childrenItem"></Overlay>

        <!--底部tab -->
        <van-tabbar
            class="live-list-footer"
            :border="false"
            :fixed="true"
            :safe-area-inset-bottom="true"
            v-model="tabbarActive"
            route
            active-color="#E4263D"
        >
            <van-tabbar-item to="/">
                <span class="live-list-footer-item">首页</span>
                <template #icon="props">
                    <div class="live-list-footer-item-text">
                        <img src="/static/v4/tabbar/icon_tab_home_1.svg" alt="" v-if="props.active" />
                        <img src="/static/v4/tabbar/icon_tab_home_2.svg" alt="" v-else />
                    </div>
                </template>
            </van-tabbar-item>
            <van-tabbar-item to="/live-list">
                <span class="live-list-footer-item">直播</span>
                <template #icon="props">
                    <div class="live-list-footer-item-text">
                        <img src="/static/v4/tabbar/icon_tab_live_1.svg" alt="" v-if="props.active" />
                        <img src="/static/v4/tabbar/icon_tab_live_2.svg" alt="" v-else />
                    </div>
                </template>
            </van-tabbar-item>
            <van-tabbar-item to="/clinic-course">
                <span class="live-list-footer-item">临床好课</span>
                <template #icon="props">
                    <div class="live-list-footer-item-text">
                        <img src="/static/v4/tabbar/icon_tab_course_1.svg" alt="" v-if="props.active" />
                        <img src="/static/v4/tabbar/icon_tab_course_2.svg" alt="" v-else />
                    </div>
                </template>
            </van-tabbar-item>
            <van-tabbar-item to="/my">
                <span class="live-list-footer-item">我的</span>
                <template #icon="props">
                    <div class="live-list-footer-item-text">
                        <img src="/static/v4/tabbar/icon_tab_me_1.svg" alt="" v-if="props.active" />
                        <img src="/static/v4/tabbar/icon_tab_me_2.svg" alt="" v-else />
                    </div>
                </template>
            </van-tabbar-item>
        </van-tabbar>
    </div>
</template>
<script>
import Interface from '@/util/interface'
import videoListSkeleton from '@/skeleton/videoListSkeleton'
import LiveColumn from './live-column.vue'
import LiveSingle from './live-single'
import Overlay from './overlay.vue'
export default {
    name: 'course-list',
    components: {
        LiveColumn,
        LiveSingle,
        Overlay,
        'video-list-skeleton': videoListSkeleton
    },
    data() {
        return {
            academicContent: '',
            value: '',
            active: '',
            tabbar_active: 1,
            category_id: 0,
            category_index: 0,
            category_child_id: 0,
            banners: [],
            categories: [],
            categories_child: [],
            recommend: [],
            list: [],
            column: [],
            forecast: [],
            backs: [],
            isLoading: true,
            backPage: {
                page: 1,
                pageSize: 30
            },
            backPagepage: 1,
            pageSize: 10,
            loading: true,
            finished: false,
            total_page: 1,
            swiperOption: {
                width: 192,
                height: 249,
                spaceBetween: 15
            },
            isOption: false,
            search_placeholder: [],
            study: [],
            study_page: 1,
            study_pageSize: 10,
            study_total_page: 1,
            tabbarActive: '/live-list',
            appointmentList: null,
            backTabsActive: 1,
            otherChannelList: [],
            contentLoading: false,
            contentFinished: false,
            contentPage: {
                page: 1,
                pageSize: 10
            },
            childrenItem: null,

            backLoading: false,
            backFinished:false,
        }
    },
    computed: {
        forecastList() {
            return !this.isOption ? this.forecast.slice(0, 3) : this.forecast
        }
    },

    methods: {
        onLoad() {
            this.loading = true
            this.backPage.page += 1
            this.fetch('reBack', false)
        },
        backLoad() {
          console.log(123123123)
            this.loading = true
            this.backPage.page += 1
            this.fetch('reBack', false)
        },
        // 跳转到搜索页面
        jump(item) {
            this.$router.push({ path: '/search-new', query: { search: JSON.stringify(item),channel:'live' } })
        },
        goEnrollment(row) {
            Interface.goLiveDetail(this, row)
        },
        goConference(item) {
            if (item.origin_type === 4) {
                Interface.goLiveDetail(this, { id: item.origin_id, type: item.type, live_status: item.live_status })
            } else if (item.origin_type === 14) {
                Interface.goMeeting(this, {
                    is_saas: item.is_saas,
                    type: item.type,
                    uuid: item.uuid
                })
            }
        },
        // 直播-一键预约
        liveApply(item) {
            if (!item.isAppointment) {
                // 判断是否认证 0 未认证   1已认证
                let user = localStorage.getItem('user')
                let is_complete = JSON.parse(user).is_complete

                if (is_complete == 1) {
                    Interface.getData('get', Interface.v4.apply + '/' + item.id).then(res => {
                        if (res.code == 0) {
                            this.childrenItem = null
                            this.childrenItem = item
                            this.$refs.overlayRef.applyShow = true
                            this.fetch('homepage')
                        }
                    })
                } else {
                    // 去认证
                    this.$dialog
                        .confirm({
                            title: '需要登录',
                            message: '为了方便学习课程,需要您登录认证',
                            confirmButtonText: '去认证'
                        })
                        .then(() => {
                            sessionStorage.setItem('back-url', this.$route.path)
                            this.$router.push({ name: 'login' })
                        })
                        .catch(() => {
                            // on cancel
                        })
                }
            } else {
                Interface.goLiveDetail(this, item)
            }
        },
        goTabBack(row) {
            this.backTabsActive = row
            this.backPage.page = 1
            this.backs = []
            this.backFinished = false
            this.fetch('reBack', true)
        },

        fetch(scene, flag) {
            if (scene === 'homepage') {
                let params = {
                    pageSize: 999,
                    category_id: this.category_id
                }
                if (this.value != '') {
                    params.title = this.value
                }
                Interface.getData('get', Interface.live.home, params).then(res => {
                    if (res.data.recommend) {
                        this.column = res.data.recommend
                    } else {
                        this.column = []
                    }

                    this.academicContent = res.data.academicContent ? res.data.academicContent : []
                    if (res.data.banners) {
                        this.banners = res.data.banners
                    } else {
                        this.banners = []
                    }
                    if (res.data.forecast) {
                        this.forecast = res.data.forecast
                    } else {
                        this.forecast = []
                    }

                    this.loading = false
                    this.isLoading = false

                    this.appointmentList = res.data.appointment || null

                    Interface.getShareInfo(this, '直播', '', '', 38,'',Interface.host + '/#/live-list?source_type=1')
                    setTimeout(() => {
                        this.loading = false
                    }, 500)
                })
            } else if (scene === 'category') {
                Interface.getData('get', '/course/api/channel', { origin_type: 4 }).then(res => {
                    this.categories = res.data.list
                    this.categories.unshift({ title: '推荐', id: 0 })
                    if (this.categories.length < 5) {
                        for (let i = 999; i <= 1007 - this.categories.length; i++) {
                            this.categories.push({ title: '', id: i })
                        }
                    }
                    let search_channel = sessionStorage.getItem('live_search_channel')
                    if (this.$route.query.live_search_channel > 0) {
                        this.category_index = parseInt(this.$route.query.live_search_channel)
                        this.changeCategory()
                    } else if (search_channel != null) {
                        this.category_index = parseInt(search_channel)
                        this.changeCategory()
                    }
                })
            } else if (scene === 'reBack') {
                // 接口新改
                // live_type  1学术会议，2临床好课，3科研好课
                Interface.getData('get', Interface.live.reBack, {
                  page: this.backPage.page,
                  pageSize: this.backPage.pageSize,
                  live_type: this.backTabsActive,
                  category_id: this.category_id
                }).then(res => {
                    if (!flag) {
                        this.backs.push(...res.data.list)
                    } else {
                        this.backs = res.data.list
                    }
                    this.backFinished = res.data.total < 10 || this.backs.length >= res.data.total;
                    this.backLoading = false
                })
            } else if (scene === 'study') {
                this.page = 1
                let params = {
                    page: this.study_page,
                    pageSize: this.study_pageSize,
                    category_id: this.category_id
                }
                if (this.value != '') {
                    params.title = this.value
                }
                Interface.getData('get', Interface.live.study, params).then(res => {
                    if (res.data && res.data.list != null) {
                        this.study = res.data.list
                        this.study_total_page = res.data.total_page
                    } else {
                        this.study = []
                        this.study_total_page = 1
                    }
                })
            } else if (scene === 'search_text') {
                // 获取底纹词
                Interface.getData('get', Interface.v4.search_list, {
                    type: 2
                }).then(res => {
                    if (res.code == 0) {
                        this.search_placeholder = res.data.hot_words
                    }
                })
            }
        },
        changeCategory() {
            sessionStorage.setItem('live_search_channel', this.category_index)
            this.$router.push({
                name: 'live-list',
                query: {
                    live_search_channel: this.category_index
                }
            })
            this.page = 1
            this.category_id = this.categories[this.category_index].id

            document.title = '直播-' + this.categories[this.category_index].title
            if (this.category_id !== 0) {
                this.otherChannelList = []
                this.fetch_more()
            }
            if (this.category_id) {
                Interface.mFootPrint(this.category_id,32,0,2,0, this.categories[this.category_index].title)
            }
        },
        fetch_more() {
            // 其他tab 使用的列表
            Interface.getData('get', `/course/api/channel/${this.category_id}`, { origin_type: 4, ...this.contentPage }).then(res => {
                if (res.code === 0) {
                    console.log(res.data.list, 'res')
                    if (res.data.list === null) {
                        this.contentFinished = true
                        return
                    }
                    if (res.data && res.data.list && res.data.list.length) {
                        this.otherChannelList.push(...res.data.list)
                    }

                    this.contentLoading = false
                    if (this.otherChannelList.length >= res.data.total_page) {
                        this.contentFinished = true
                    }
                }
                setTimeout(() => {
                    this.isLoading = false
                }, 500)
            })
        },
        go_detail(item) {
            Interface.goLiveDetail(this, item)
            Interface.getShareBaseInfo(this, '直播-' + item.title, '', '')
            Interface.mFootPrint(item.id, 38,0, 6, 0, item.title)
        },
        go_channel_detail(item) {
            Interface.goLiveDetail(this, {
                id: item.origin_id,
                isAppointment: item.isAppointment,
                live_status: item.live_status,
                type: item.type
            })
            Interface.getShareBaseInfo(this, '直播-' + item.title, '', '')
        },
        goBanner(item) {
            Interface.mFootPrint(item.id,33,0,2,0, item.title)
        },
        go_calendar() {
          this.$router.push({ path: '/activity-list' })
            Interface.mFootPrint(1,47,0,0,0, '会议日历')
        },
        go() {
          this.$router.push({ name: 'topic-detail', params: { id: 4 } })
          Interface.mFootPrint(2,47,0,0,0, '国际视野')
        }
    },

    created() {
        Interface.initChannel('live')
        this.fetch('banner')
        this.fetch('category')
        this.fetch('homepage')
        this.fetch('reBack', true)
        this.fetch('search_text')
        this.fetch('study')

        let source_type = Interface.getUrl(window.location.href)
        if (source_type) {
            Interface.mFootPrint(0, 38,0, 2, source_type, '直播页')
        } else {
            Interface.mFootPrint('',38,0,2,0,'直播页')
        }
    },
}
</script>
<style lang="scss">
@import './index';
</style>



// WEBPACK FOOTER //
// src/views/live/list/index.vue